<div *ngIf="_authService.isAuthenticated()" class="menu-sidebar d-flex jc-sb fd-col" (mouseleave)="mouseLeave()"
    [ngClass]="{'expanded':toggleState === 'expanded','collapsed':toggleState === 'collapsed','mobile':isMobileSize,'show-sidebar':showSidebar}"
    #sidebar>
    <div class="main-menu-content">
        <div class="menu-header" *ngIf="isMobileSize">
            <div class="menu-header-user-info">
                <nb-icon pack="fontawesome" class="fal fa-user icon-user"></nb-icon>
                {{ setUserName() }}
            </div>
            <a class="menu-header-icon" (click)="hideSidebar()">
                <nb-icon pack="fontawesome" class="fal fa fa-times"></nb-icon>
            </a>
        </div>

        <div class="wallet border rounded mx-2" *ngIf="_authService.isAuthenticated() && env.userWalletInventory">

            <div class="wallet-btn-contianer">
                <button (click)="goToWallet()" class="wallet-btn">
                    <nb-icon pack="fontawesome" class="fal fa-2x fa-wallet icon-style"></nb-icon>
                </button>
            </div>
            <div class="wallet-text">
                <span class="wallet-title">کیف پول</span>
                <span class="wallet-amount">{{env.userWalletInventory}}</span>
                <br>
                <span class="wallet-text-sub" (click)="goToWallet()">
                    شارژ کیف پول
                    <nb-icon pack="fontawesome" class="fal fa-solid fa-arrow-left"></nb-icon>
                </span>
            </div>
        </div>
        <hr *ngIf="_authService.isAuthenticated() && env.userWalletInventory">

        <div class="full-width-item pin-sidebar mt-4" *ngIf="!isMobileSize">
            <a (click)="toggleSidebar()" title="سنجاق کردن" class="sidebar-toggle pointer">
                <div class="ml-7" *ngIf="toggleState === 'collapsed'">
                    <!-- <nb-icon icon="radio-button-off-outline"></nb-icon> -->
                    <i class="fal fa-circle"></i>
                </div>
                <div *ngIf="toggleState === 'expanded'">
                    <!-- <nb-icon pack="fontawesome" icon="fal fa-dot-circle"></nb-icon> -->
                    <i class="fal fa-dot-circle"></i>
                </div>
            </a>
        </div>
        <div class="full-width-item d-flex jc-e mt-4" *ngIf="isMobileSize">
            <a (click)="hideSidebar()" title="بستن" class="sidebar-toggle pointer">
                <div class="ml-7">
                    <nb-icon pack="fontawesome" class="fal fa-times-circle"></nb-icon>
                </div>
            </a>
        </div>
        <ul class="menu-items" [ngClass]="[toggleState]">
            <ng-container *ngFor="let item of items">
                <li dgMenuItem *ngIf="!item.hidden" [menuItem]="item" [badge]="item.badge"
                    [class.menu-group]="item.group" (selectItem)="onSelectItem($event)"
                    (itemClick)="onItemClick($event)" class="menu-item">
                </li>
            </ng-container>
        </ul>
    </div>
    <div class="footer-content" *ngIf="lastBuildDate || !permissions.upgradeUser">
        <div class="upgrade-user-link" *ngIf="!permissions.upgradeUser">
            <a [routerLink]="['/profile/promote-account']" class="d-flex ai-c w-100">
                <i class="isax icon-user-tick footer-icon"></i>
                <div class="coworker">
                    <p class="text">ارتقای حساب</p>
                </div>
            </a>
        </div>
        <p class="build-number" *ngIf="lastBuildDate" [title]="lastBuildDate">
            Build Number : {{ buildNumber }}
        </p>
    </div>

    <div class="exit-contianer" fullWidth>
        <button nbButton ghost fullWidth [routerLink]="['/auth/logout']" class="exit-button">
            <nb-icon pack="fontawesome" class="fal fa-sign-out red"></nb-icon>
            <p class="mr-5">خروج از حساب</p>
        </button>
    </div>
</div>

<div *ngIf="_authService.isAuthenticated() && isMobileSize" class="main-menu-sidebar d-flex fd-col mobile"
    [ngClass]="{'show-menu':showMenu}" #menu>
    <div>
        <div class="main-menu-content">
            <div class="menu-header">
                <a class="menu-header-icon" (click)="hideMenu()">
                    <nb-icon pack="fontawesome" class="fal fa fa-times"></nb-icon>
                </a>

                <img class="logo" src="../../../assets/img/Component 1 1.svg" />
            </div>
        </div>

        <hr>

        <ul class="menu-items">
            <ng-container *ngFor="let item of header">
                <li dgMenuItem [menuItem]="item" [class.menu-group]="item.group" (selectItem)="onSelectItem($event)"
                    (itemClick)="onItemClick($event)" class="menu-item">
                </li>
            </ng-container>
        </ul>
    </div>
</div>